import * as angular from "angular";
import * as _ from "lodash";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import LineConfigsServiceName, {LineConfigsService, LineItem, LineJunctionItem}
  from "../../services/lineConfigs/lineConfigs.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import template from './editLine.tpl.html';

let requires = [LineConfigsServiceName, NewGuidServiceName, LoaderServiceName, NotifyServiceName];

export interface EditLine {
  save(): void;
  close(): void;
  editedLineEndJunctionChanged(): void;
  dialogHeaderText: string;
  isNew: boolean;
  form: angular.IFormController;
  editedLine: LineItem;
  eligibleEndJunctions: LineJunctionItem[];
}

export function openEditLine(data: EditLineData,
                             $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'EditLineCtrl as vm',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

export interface EditLineData {
  line: apsViewModels.LineItem;
  shop: apsViewModels.ShopNavigation;
  startJunction: LineJunctionItem;
  eligibleEndJunctions: LineJunctionItem[];
}

export default angular.module('aps.controller.editLine', requires)
  .controller('EditLineCtrl', editLineCtrl)
  .name;

function editLineCtrl(newGuidService: NewGuidService,
                      loaderService: LoaderService,
                      notifyService: NotifyService,
                      lineConfigsService: LineConfigsService,
                      $modalInstance: mm.foundation.modalInstance,
                      data: EditLineData): EditLine {

  let vm = {} as EditLine;

  vm.dialogHeaderText = 'Add Line';
  vm.editedLine = <LineItem>{};
  vm.eligibleEndJunctions = data.eligibleEndJunctions;

  if (data.line) {
    _.assign(vm.editedLine, data.line);
    vm.dialogHeaderText = 'Edit Line Name';
    vm.isNew = false;
  } else {
    vm.isNew = true;
    newGuidService.getNewGuid('line').then(id => vm.editedLine.id = id.toString());
    vm.editedLine.shopId = data.shop.id;
    vm.editedLine.startJunctionId = data.startJunction ? data.startJunction.id : undefined;
    vm.editedLine.startJunction = data.startJunction;
    let maxNumber = 0;
    if (data.startJunction && data.startJunction.outputs.length > 0) {
      maxNumber = _.max<number>(data.startJunction.outputs.map(n => n.number));
    }
    vm.editedLine.number = maxNumber + 1;
  }

  vm.save = () => {
    if (vm.form.$invalid) {
      return;
    }

    vm.editedLine.name = vm.editedLine.name.toUpperCase();

    let promise = vm.isNew
      ? lineConfigsService.addLine({
        id: vm.editedLine.id,
        shopId: data.shop.id,
        name: vm.editedLine.name,
        number: vm.editedLine.number,
        endJunctionId: vm.editedLine.endJunctionId,
        startJunctionId: vm.editedLine.startJunctionId
      })
      : lineConfigsService.updateLine({
        id: vm.editedLine.id,
        shopId: data.shop.id,
        name: vm.editedLine.name
      });

    loaderService.loadingPromise(promise.then(() => {
      $modalInstance.close(vm.editedLine);
    }, notifyService.handleApiErrors));
  };

  vm.close = () => {
    $modalInstance.close();
  };

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/lineConfigs/editLine.controller.ts